import AllDayItem from '../schema/AllDayItem';
import { CalendarEvent } from 'mini-calendar-event-types';

/**
 * Takes an ordered set of calendar events, filters out all day events and returns the dayViewAllDayItems from that to be placed in the day view
 * @param events
 */
const convertAllDayCalendarEventsToAllDayItems = (events: CalendarEvent[]): AllDayItem[] =>
    events
        .filter(event => event.IsEffectiveAllDayEvent)
        .map(
            (event: CalendarEvent): AllDayItem => ({
                data: event,
            })
        );

export default convertAllDayCalendarEventsToAllDayItems;
